import { css } from '@/styled-system/css';

export const dropdownFooterStyles = css.raw({
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: 'auto',
  display: 'flex',
  justifyContent: 'flex-end',
  paddingBlock: 'default',
  paddingInline: 'default',
});
